module.exports = __webpack_public_path__ + "media/images/signup-rocket-767c40de167984e7363e634a11efc36a.svg";